<template>
  <div class="spirit">
    <header :style="{backgroundColor:boxBodyColor}">

      <img v-if="displayMode == 2" :src="logoUrl" alt="公司logo">
      <p  v-else class="companyName">
        <span v-if="companyName == ''"></span>

        <el-tooltip v-else-if="companyName.length > 10" :content="companyName" placement="top" effect="light">
          <span>{{companyName.substring(0,10) + '...'}}</span>
        </el-tooltip>

        <span v-else>{{companyName}}</span>
      </p>
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="首页" name="0">首页</el-tab-pane>
        </el-tabs>
      </div>
      <div class="orderAndService">
        <img v-show="callis" @click="callgo" :src="imgUrl + 'callbtn.png'" alt="客服电话logo" >
        <span v-show="callis" @click="callgo" class="order" >客服电话</span>

        <img :src="imgUrl + 'im_logo.png'" alt="单据logo" @click="workOrder">
        <span class="order" @click="workOrder">我的单据</span>



        <img :src="imgUrl + 'im_service.png'" alt="在线客服logo" v-if="vip && turnToIm && visitorVipLevel != null && limitVipLevel != null && visitorVipLevel >= limitVipLevel" @click="intoIm">
        <span class="order" v-if="vip && turnToIm && visitorVipLevel != null && limitVipLevel != null && visitorVipLevel >= limitVipLevel" @click="intoIm">在线客服</span>
      </div>
    </header>
    <section class="content">
      <div class="left">
        <div class="chat">
          <template v-for="(item,index) in spiritSession">
            <div class="service" v-if="item.type == 1">
              <div class="serviceImg">
                <img :src="spiritSrc" alt="系统头像">
              </div>

              <div class="serviceSession">
                <span class="sessionSpan"></span>
                <div class="chatText">
                  <div class="sessionDiv" v-dompurify-html="item.content"></div>
                  <div v-if="item.workOrders && item.workOrders.length > 0" class="workOrder-box">
                    <div v-for="obj in item.workOrders" :key="obj.id" class="workOrder-item">
                      <!-- <el-button plain @click="goForm(obj)">{{obj.name}}</el-button> -->
                      <p class="workOrder-btn" @click="goForm(obj)">{{obj.name}}</p>
                    </div>
                  </div>
                  <p class="sessionBar" v-if="item.evaluateShow"></p>
                  <!--<div class="evaluate" v-if="item.evaluateShow && item.questionId != '0'">-->
                  <div class="evaluateDiv" v-if="item.evaluateShow && item.questionId != '0'">

                    <p class="evalP" v-if="!item.isEvaluate">评价有惊喜哦~~</p>

                    <div class="evaluate">

                      <div v-if="!item.isEvaluate" class="evalDiv">
                        <div class="evaluateP" @click="getEvaluate(3,index)" :style="{backgroundColor:boxBodyColor,borderColor:boxBodyColor}">
                          <img :src="imgUrl + 'zanT.png'" alt="">
                          <p class="getP">解决</p>
                        </div>
                      </div>

                      <p v-if="!item.isEvaluate" class="bar"></p>

                      <div v-if="!item.isEvaluate" class="evalDiv">
                        <div class="evaluateP" @click="getEvaluate(1,index)" :style="{backgroundColor:boxBodyColor,borderColor:boxBodyColor}">
                          <img :src="imgUrl + 'zan.png'" alt="">
                          <p class="getP">未解决</p>
                        </div>
                      </div>

                      <p v-else class="evaluated" style="padding-top:20px;">感谢您的评价</p>

                    </div>

                    <p v-if="item.relativeQuestions && item.relativeQuestions.length > 0" class="evaluateBar"></p>


                    <!--<div class="evaluateSession">-->
                      <!--<p>请您对我的服务做出评价</p>-->
                      <!--<div v-if="!item.isEvaluate">-->
                        <!--<div class="satisfaction">-->
                          <!--<img :src="0 == currentIndex ? '/pc/static/assets/im_star1_bright.png' : '/pc/static/assets/im_star1_dark.png'" alt="满意" @click="getEvaluate(0,3,index)">-->
                          <!--<p>满意</p>-->
                        <!--</div>-->
                        <!--<div class="yawp">-->
                          <!--<img :src="1 == currentIndex ? '/pc/static/assets/im_star3_bright.png' : '/pc/static/assets/im_star3_dark.png'" alt="不满意" @click="getEvaluate(1,1,index)">-->
                          <!--<p>不满意</p>-->
                        <!--</div>-->
                      <!--</div>-->
                      <!--<div v-else>-->
                        <!--感谢您的评价-->
                      <!--</div>-->
                    <!--</div>-->
                  </div>

                  <p class="topFiveP" v-if="item.relativeQuestions && item.relativeQuestions.length > 0 && item.evaluateShow">相关问题推荐</p>
                  <ul class="topFive">
                    <li v-for="(relativeQ,indexF) in item.relativeQuestions">
                      <a href="javaScript:void(0)" @click="getTopFive(relativeQ)">{{relativeQ}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="user" v-if="item.type == 2">
              <span class="sessionUser"></span>
              <div class="userSession">
                <!--<div class="userText" v-dompurify-html="item.content">-->
                  <!---->
                <!--</div>-->
                <div class="userText">
                  <p v-for="i in item.content">{{i}}</p>
                </div>
              </div>
              <div class="userImg">
                <img src="../../../static/assets/im_group_10.png" alt="用户头像">
              </div>
            </div>
          </template>
        </div>
        <footer>
          <textarea class="chatContent" maxlength="140" v-model="chatContent" @keyup="sendMsg(chatContent,$event)" @keydown="sendMsg1(chatContent,$event)"></textarea>
          <div class="send">
            <span>按下Ctrl+Enter换行</span>
            <el-button :style="{backgroundColor:boxBodyColor,borderColor:boxBodyColor}" type="primary" class="sendBtn" size="small" @click="getTopFive(chatContent)">发送</el-button>
          </div>

          <div class="lenovo" v-if="lenovoShow">
            <div v-for="(relativeQ,indexF) in questions">
              <a href="javaScript:void(0)" @click="getTopFive(relativeQ.content)"  v-dompurify-html="relativeQ.html"></a>
            </div>
          </div>
        </footer>
      </div>
      <div class="right">
        <div class="hotTitle">
          <p>热点问题</p>
        </div>
        <nav>
          <ul>
            <li v-for="(hotItem,index) in hotArr">
              <a href="javaScript:void(0)" @click="getTopFive(hotItem)">{{hotItem}}</a>
            </li>
          </ul>
        </nav>
      </div>
    </section>

    <div class="imgMask" v-if=" showImgMask && (geen == -1) " @click="magnify(imgMasksrc)" @mousewheel="bbimg()">
      <img @click.stop="stopImg" ref="img" :src="imgMasksrc" alt="放大图">
    </div>

    <div class="imgMask" v-else-if="showImgMask && (geen > -1)" @click="magnify(imgMasksrc)" @DOMMouseScroll="bbimg2()">
      <img @click.stop="stopImg" ref="img" :src="imgMasksrc" alt="放大图">
    </div>

  </div>
</template>

<script>
  import Api from '../../api/question'
  import * as Url from '@/components/url.js'
  import _ from 'lodash'
//  import {mapGetters} from 'vuex'
  var vm = {}
  export default {
    data () {
      vm = this
      return {
        basicUrl:Url.baseurl,
        visitorMd5Code:'',
        imEntranceMode:'',
        boxBodyColor:'',
        logoUrl:'',
        companyName:'',
        displayMode:'',
        imgUrl: '/pc/static/assets/',
        hotArr:[],
        spiritSession:[],
        chatTopFive:{},
        chatContent:'',
        gainObj:{},
        turnToIm:false,
        activeName: '0',
//        isEvaluate:false,
//        trigger:'',

        tripleMiss: false,
        times: 3,
        notSatisfied: false,
        vip: false,

        num:'',
        evaArr:[],
        customPicture:'',
        defaultPictureNo:'',
        headPictureUrl:'',
        spiritSrc: '/pc/static/assets/spirit1.png',
        lenovoShow: false,
        questions: [],
        callis : false,
        limitVipLevel: '',
        visitorVipLevel: '',

        imgMasksrc: '',
        showImgMask: false,
        params : {
          zoomVal:1,
          left: 0,
          top: 0,
          currentX: 0,
          currentY: 0,
          flag: false
        },
        firstPage: false,
        geen: navigator.userAgent.indexOf('Firefox'),
        homeType: -1
      }
    },
    computed: {
      source: function ()  {
        return this.$route.query.source
      },
      chatType: function ()  {
        return (this.$route.query.chatType == 'true' || this.$route.query.chatType == true) ? true : false
      },
    },
    /**
     * 离开精灵会话时会触发此钩子
     */
    beforeRouteLeave (to, from, next) {
      // 点击我的单据日志埋点
      if (this.homeType == 5) {
        // 跳转到人工
        if (to.name == 'IMLineUp' || to.name == 'ImSession' || to.name == 'ImDirectory') {
          this.$Points.point({code: '1004', type: '1'});
          // 点击右上角跳转到我的工单
        } else if (to.name == 'myorder') {
          this.$Points.point({code: '1004', type: '3'});
          // 玩家退出
        } else if (to.name !== 'workinformation' && to.name !== 'workcommit') {
          this.$Points.point({code: '1004', type: '2'});
        }
      }
      // 结束会话
      if(to.path == '/imLineUp' || to.path == '/imDirectory'){
        vm.unSolved()
        next();
      }else {
        vm.solved()
        next();
      }
    },
    mounted(){
      // 监听 `onbeforeunload` 事件
      // 访客离开精灵页面（点击返回、刷新、点击首页、直接点击在线客服，直接关闭浏览器等等导致离开），
      // 精灵会话结束，在历史会话能看到此条会话记录。
      function addOnBeforeUnload(e) {
//        vm.unSolved() // 生成一个会话记录
        vm.solved();
      }

      if(window.attachEvent){
        //window.attachEvent('onbeforeunload', addOnBeforeUnload);
      } else {
        window.addEventListener('beforeunload', addOnBeforeUnload, false);
      }
      // 取得浏览器的userAgent字符串
      let userAgent = navigator.userAgent;

      vm.visitorMd5Code = sessionStorage.getItem('md5')
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')

      vm.logoUrl = sessionStorage.getItem('logoUrl')
      vm.displayMode = sessionStorage.getItem('displayMode');

      vm.customPicture = sessionStorage.getItem('customPicture')
      vm.defaultPictureNo = sessionStorage.getItem('defaultPictureNo')
      vm.headPictureUrl = sessionStorage.getItem('headPictureUrl')
      vm.homeType = sessionStorage.getItem('redirectTarget')
      if(vm.customPicture == 'true'){
        vm.spiritSrc = vm.headPictureUrl
      }else {
        if(vm.defaultPictureNo == 2){
          vm.spiritSrc = '/pc/static/assets/spirit2.png'
        }else if(vm.defaultPictureNo == 3){
          vm.spiritSrc = '/pc/static/assets/spirit3.png'
        }else{
          vm.spiritSrc = '/pc/static/assets/spirit1.png'
        }
      }
      if(sessionStorage.getItem('callCenterEnable') == 'true'){

        this.callis = true;
      }

      vm.num = 0
      vm.initialize();
      vm.axios.get(vm.basicUrl + "/api/visitor/im/entrance?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
        if(response.data.code == 1){
          vm.imEntranceMode = response.data.data.mode

        } else {

        }
      }, function (response) {
        console.info(response)
      })
      if (this.source) {
        if (this.source == 'type') {
          this.getType()
        } else if (this.source == 'hot') {
          this.getHot()
        }
      }
    },
//    computed: {
//      ...mapGetters({
//        companyName: 'getCompanyName'
//      })
//
//    },
    methods:{
      handleClick() {
        const url = sessionStorage.getItem('indexUrl')
        const md5 = sessionStorage.getItem('md5')
        if (!url) {
          return
        }
        this.$router.push({
          path: url,
          query: {
            v: md5
          }
        })
      },
      /**
       * 监听用户离开事件
       */
      // listenrerBeforeUnload () {
      //   window.onbeforeunload = function (e) {
      //     let str = '确定要关闭浏览器吗？'
      //     vm.unSolved() // 生成一个会话记录
      //     e.returnValue = str
      //     return str
      //   }
      // },
      getType() {
        Api.getTypeDetails({visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id}, res => {
          if (res.code === 1) {
            this.readQuestion(res.data)
          }
        })
      },
      getHot() {
        Api.getHotIssue({visitorMd5Code: this.visitorMd5Code, id: this.$route.query.id}, res => {
          if (res.code === 1) {
            this.readQuestion(res.data)
          }
        })
      },
      readQuestion(info) {
        const firstReplyAndTop5 = {}
        firstReplyAndTop5.type = 2
        firstReplyAndTop5.content = ((info.question || info.questionName) || '').split('\n')
        firstReplyAndTop5.relativeQuestions = []
        firstReplyAndTop5.evaluateShow = false
        this.spiritSession.push(firstReplyAndTop5)
        const answerObj = { ...firstReplyAndTop5, type: 1, content: info.answer || info.faq }
        this.spiritSession.push(answerObj)
        this.scrollToBottom();
      },
      goForm(obj) {
        if (this.homeType == 5) {
          this.$Points.point({code: '1004', type: '3', id: obj.id});
        }
        sessionStorage.setItem("navname", obj.name);
        if (obj.showNote) {
          this.$router.push({
            path: '/workinformation',
            query: {
              id: obj.id,
              source: this.homeType == 5?'ai':'',
              // name: obj.name
            }
          })
        } else {
          this.$router.push({
            path: '/workcommit',
            query: {
              id: obj.id,
              source: this.source?'ai':'',
              // name: obj.name
            }
          })
        }
      },
      stopImg(){},
      bbimg2(){

        var v = event.wheelDelta || event.detail,
            vm = this

        vm.params.zoomVal -= v/20

        if (vm.params.zoomVal >= 0.2) {
          vm.$refs.img.style.transform="scale("+vm.params.zoomVal+")";
        } else {
          vm.params.zoomVal=0.2;
          vm.$refs.img.style.transform="scale("+vm.params.zoomVal+")";
          return false;
        }

      },
      bbimg(){

        var event = event || window.event,
            vm = this

        vm.params.zoomVal+=event.wheelDelta/600;

        vm.$refs.img.style.transform="scale("+vm.params.zoomVal+")";

        if (vm.params.zoomVal >= 0.2) {
          vm.$refs.img.style.transform="scale("+vm.params.zoomVal+")";
        } else {
          vm.params.zoomVal=0.2;
          vm.$refs.img.style.transform="scale("+vm.params.zoomVal+")";
          return false;
        }

      },
      magnify (src) {
        this.imgMasksrc = src;
        this.showImgMask = !this.showImgMask;

        if(!this.showImgMask){
            this.params = {
              zoomVal:1,
              left: 0,
              top: 0,
              currentX: 0,
              currentY: 0,
              flag: false
          }
        }

        var vm = this

        var getCss = function(o,key){
          return o.currentStyle? o.currentStyle[key] : document.defaultView.getComputedStyle(o,false)[key];
        };
        //拖拽的实现
        var startDrag = function(bar, target, callback){
          if(getCss(target, "left") !== "auto"){
            vm.params.left = getCss(target, "left");
          }
          if(getCss(target, "top") !== "auto"){
            vm.params.top = getCss(target, "top");
          }
          //o是移动对象


          bar.onmousedown = function(event){

            vm.params.flag = true;

            if(!event){
              event = window.event;
              //防止IE文字选中
              bar.onselectstart = function(){
                return false;
              }
            }

            var e = event ? event: window.event

            e.stopPropagation();
            e.preventDefault();
            vm.params.currentX = e.clientX;
            vm.params.currentY = e.clientY;
          };



          document.onmouseup = function(){
            vm.params.flag = false;

            if(getCss(target, "left") !== "auto"){
              vm.params.left = getCss(target, "left");
            }
            if(getCss(target, "top") !== "auto"){
              vm.params.top = getCss(target, "top");
            }
          };
          document.onmousemove = function(event){

            var e = event ? event: window.event;

            if(vm.params.flag){
              var nowX = e.clientX, nowY = e.clientY;
              var disX = nowX - vm.params.currentX, disY = nowY - vm.params.currentY;
              target.style.left = parseInt(vm.params.left) + disX+ "px";
              target.style.top = parseInt(vm.params.top) + disY+ "px";
              if (typeof callback == "function") {
                callback((parseInt(vm.params.left) || 0) + disX, (parseInt(vm.params.top) || 0) + disY);
              }
              if (e.preventDefault) {
                e.preventDefault();
              }
              return false;
            }
          }
        };

        if(vm.$refs.img) {
          startDrag(vm.$refs.img,vm.$refs.img)
        }else {
          var time = setInterval(()=>{
            if(vm.$refs.img){
              startDrag(vm.$refs.img,vm.$refs.img)
              clearInterval(time)
            }else {
              time()
            }
          },500)
        }

      },
      callgo(){

        var userAgent = checkBrowser();
        var changeis = true;
        if(userAgent == '谷歌'){
          changeis = true;
          var banben = getChromeVersion();
          console.log('浏览器版本：'+banben)
          if(banben < 52){
            changeis = false;
          }
        }else{
          changeis = false;
        }
        if(changeis){
          window.location.href = '#/callcenter';
        }else{
            if(userAgent != "Safari"){
              this.$message({
                message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
                type: 'warning'
              })
            }else{
              alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
            }
        }

      },
      workOrder(){
        vm.$router.replace({path: 'myorder'})
      },
      /*初始化问题*/
      initialize(){
        vm.axios.get(vm.basicUrl + "/api/visitor/spirit/spiritInit?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
          if(response.data.code === 1){
            vm.chatTopFive.type = 1
            vm.chatTopFive.content = response.data.data.content
            vm.chatTopFive.relativeQuestions = response.data.data.relativeQuestions
            vm.chatTopFive.evaluateShow = false
            vm.chatTopFive.workOrders = response.data.data.workOrders
            vm.hotArr = response.data.data.relativeQuestions

            vm.turnToIm = response.data.data.turnToIm

            if(response.data.data.spiritImEntranceCfgs){
              response.data.data.spiritImEntranceCfgs.forEach(function (item,index) {
                if(item.triggers == 1){
                  vm.tripleMiss = true
                  vm.times = item.times
                }

                if(item.triggers == 2){
                  vm.notSatisfied = true
                }

                if(item.triggers == 3){
                  vm.vip = true
                  vm.limitVipLevel = item.vipLevel
                }

                vm.visitorVipLevel = response.data.data.visitorVipLevel

              })
            }
            // 不是来源于热点问题或者问题分类
            if (!vm.source) {
              vm.spiritSession.push(vm.chatTopFive)
            }
            vm.$nextTick(()=> {

              var arr = document.querySelectorAll('body .sessionDiv a')

              for(let i = 0; i < arr.length; i++) {

                arr[i].onclick = function (e) {

                  if(arr[i].href == 'about:blank' || arr[i].href == 'javascript:void(0);' || arr[i].href == 'http://about:blank/'){
                    e.preventDefault()
                    vm.getTopFive(arr[i].innerText)
                  }

                }

              }

              var imgArr = document.querySelectorAll('body .sessionDiv img')

              for(let i = 0; i < imgArr.length; i++) {

                imgArr[i].onclick = function (e) {

                  vm.magnify(this.src)

                }

              }

            })

          } else {
            vm.$message({
              message: response.data.message || '获取问题列表失败',
              type: 'warning'
            })
          }
        }, function (response) {
          console.info(response)
        })
      },
      /*top5*/
      getTopFive(val){
        /*追问记录*/
        if(!val.trim()){
          vm.$message({
            message: '请输入要询问的内容',
            type: 'warning'
          })
        }else {
          let questionObj = {
            content: val.split('\n'),
            type: 2
          }
          vm.spiritSession.push(questionObj)
          vm.scrollToBottom()

          vm.chatContent = ''
          vm.lenovoShow = false;
          let source = ''
          if (vm.homeType == 5) {
            if (vm.source == 'type') {
              source = '3'
              // vm.$Points.point({code: '1002', type: '3'});
            } else if (vm.source == 'hot') {
              source = '2'
              // vm.$Points.point({code: '1002', type: '2'});
            } else {
              source = '1'
              // vm.$Points.point({code: '1002', type: '1'});
            }
          }
          //var url = encodeURI(vm.basicUrl + '/api/visitor/spirit/question?question='+encodeURIComponent(val)+'&visitorMd5Code='+vm.visitorMd5Code);
          var url = vm.basicUrl + '/api/visitor/spirit/question?question='+encodeURIComponent(val)+'&visitorMd5Code='+vm.visitorMd5Code + '&talkId='+vm.$Points.talkId + '&source=' + source;
          vm.axios.post(url).then(function (response) {
            if (response.data.code == 1) {
              let answerObj = {
                content: response.data.data.text,
                relativeQuestions:response.data.data.relateQuestions,
                type: 1,
                evaluateShow: true,
                isEvaluate: false,
                questionId: response.data.data.questionId,
                relatedId: response.data.data.relatedId,
                workOrders: response.data.data.workOrders
              }

              vm.gainObj = {
                relatedId: response.data.data.relatedId,
              }
              vm.evaArr.push(vm.gainObj)
              vm.spiritSession.push(answerObj)
              vm.scrollToBottom()

              if(answerObj.questionId == '0'){
                vm.num += 1
                if(vm.turnToIm && vm.num >= vm.times && vm.tripleMiss){
                  vm.unSolved()
                  // im不在会话中才可以跳转
                  if (!vm.chatType) {
                    if(vm.imEntranceMode == 2){
                      vm.$router.replace({path: 'imDirectory'})
                    }else if(vm.imEntranceMode == 1){
                      vm.$router.replace({path: 'imLineUp'})
                    }
                  }
                }
              }

//
//            vm.gainObj = {
//              catalogId:response.data.data.catalogId,
//              feedBackId:response.data.data.id,
//              isAssociate:response.data.data.sameTopCount > 0? 1 :0,
//              question:val,
//              questionId:response.data.data.questionId,
//              msgId:response.data.data.answerSeq,
//            }
//
//            vm.evaArr.push(vm.gainObj)
//
//            let evaluateObj = {
//              type: 3,
//              isEvaluate: false,
//              questionId: response.data.data.questionId,
//            }
//
//           // vm.isEvaluate = false
//
//            vm.spiritSession.push(evaluateObj)


              vm.$nextTick(()=> {

                var arr = document.querySelectorAll('body .sessionDiv a')

                for(let i = 0; i < arr.length; i++) {

                  arr[i].onclick = function (e) {

                    if(arr[i].href == 'about:blank' || arr[i].href == 'javascript:void(0);' || arr[i].href == 'http://about:blank/'){
                      e.preventDefault()
                      vm.getTopFive(arr[i].innerText)
                    }

                  }

                }


                var imgArr = document.querySelectorAll('body .sessionDiv img')

                for(let i = 0; i < imgArr.length; i++) {

                  imgArr[i].onclick = function (e) {

                    vm.magnify(this.src)

                  }

                }

              })

            }else if(response.data.code == 4103){
              vm.$message({
                message: '机器人会话不存在',
                type: 'warning'
              })
              window.location.reload()
            }
          }).catch(function (error) {
            console.log(error);
          });
        }


      },
      /*发送消息*/
      sendMsg: _.throttle(function (val,e) {
        if(vm.chatContent.trim() != ''){
          val = val.replace(/ /g,'');
          var url = encodeURI(vm.basicUrl + '/api/visitor/spirit/think?question='+val+'&visitorMd5Code='+vm.visitorMd5Code);
            vm.axios.post(url).then(function (response) {
              if (response.data.code == 1) {
                response.data.data.forEach( function(element, index) {
                  if(val == '.'){
                    element.html = element.content.replace(eval('/\\'+val+'/g'),"<span  style='color:red'>"+val+"</span>");
                  }else{
                    element.html = element.content.replace(eval('/'+val+'/g'),"<span  style='color:red'>"+val+"</span>");
                  }

                });
                console.log(response.data.data);
                vm.questions = response.data.data;

                if(!document.getElementsByClassName('chatContent')[0].value.trim()){
                  vm.lenovoShow = false
                }else if(vm.questions.length>0){
                  vm.lenovoShow = true
                }else {
                  vm.lenovoShow = false
                }

                vm.scrollToBottom()
              }
            }).catch(function (error) {
              console.log(error);
            });


        }else {
          vm.lenovoShow = false
        }
      },500),
      sendMsg1(val,e){

        if(document.getElementsByTagName('textarea')[0].value.length == 140 && e.keyCode!=8 ){
          this.$message({
            type: 'warning',
            message: '您输入超过上限了~'
          });
        }
        if(e.keyCode === 13 && !e.ctrlKey){
          vm.getTopFive(val)
          e.preventDefault();
          return false;
        }else if(e.ctrlKey && e.keyCode === 13) {
          document.getElementsByTagName('textarea')[0].value=document.getElementsByTagName('textarea')[0].value+'\r';
          return false;
        }
      },
      /*发送评价*/
      getEvaluate(val,indexS){

        for(var i=0;i<vm.evaArr.length;i++){
          for(var j=0;j<vm.spiritSession.length;j++){
            if(vm.spiritSession[j].relatedId == vm.evaArr[i].relatedId && j == indexS) {

              vm.evaArr[i].score = val

              vm.axios.post(vm.basicUrl + '/api/visitor/spirit/feedBack?visitorMd5Code=' + vm.visitorMd5Code,vm.evaArr[i]).then(function (response) {
                if (response.data.code == 1) {

                  if(vm.turnToIm && val == 1 && vm.notSatisfied){
                    vm.unSolved()
                    // im不在会话中才可以跳转
                    if (!vm.chatType) {
                      if(vm.imEntranceMode == 2){
                        vm.$router.replace({path: 'imDirectory'})
                      }else if(vm.imEntranceMode == 1){
                        vm.$router.replace({path: 'imLineUp'})
                      }
                    }
                  }

                }
              }).catch(function (error) {
                console.log(error);
              });

              vm.spiritSession[j].isEvaluate = true

            }
          }
        }

      },
      scrollToBottom(){
        var chat = document.getElementsByClassName('chat')[0];
        if(chat.scrollHeight){
          setTimeout(function () {

            chat.scrollTop = chat.scrollHeight;
          }, 100);
        }

      },
      unSolved(){
        vm.axios.get(vm.basicUrl + "/api/visitor/spirit/unSolved?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
          if(response.data.code === 1){

          } else {

          }
        }, function (response) {
          console.info(response)
        })
      },
      solved(){
        vm.axios.get(vm.basicUrl + "/api/visitor/spirit/solved?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
          if(response.data.code === 1){

          } else {

          }
        }, function (response) {
          console.info(response)
        })
      },
      /*定位到最新的消息位置*/
      intoIm(){
        var vm=this;
        vm.axios.get(vm.basicUrl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+vm.visitorMd5Code).then(function(response){
          //console.log(response)
          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus=="waiting"){
              vm.$router.replace({path: 'imDirectory'});
              //window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){
              vm.$router.replace({path: 'imSession'});
              //window.location.href="#/imSession";
            }else{
              if(vm.imEntranceMode==1){
                //window.location.href="#/spirit";
                vm.$router.replace({path: 'imLineUp'});
              }
              if(vm.imEntranceMode==2){
                vm.$router.replace({path: 'imDirectory'});
                //window.location.href="#/imDirectory";
              }
            }
          }
        })
      },
    }
  }
</script>

<style>
  .spirit .sessionDiv img {

    max-width: 100% !important;

  }
</style>

<style scoped>
  /*头部样式*/
  .companyName {
    text-indent: 2em;
  }
  .companyName > span {
    font-size: 16px;
  }
  .spirit {
    height: 100%;
  }
  .spirit .el-button--primary {
    color: #fff;
    background-color: #009688;
    border-color: #009688;
  }
  header {
    display: flex;
    align-items: center;
    background-color: #009688;
    justify-content: space-between;
    height: 45px;
    font-size: 14px;
    color: #f4f9f8;
  }
  header > img {
    height: 35px;
    width: auto;
    margin-left: 20px;
  }
  .orderAndService {
    display: flex;
    align-items: center;
  }
  .order {
    margin: 0 20px 0 12px;
    cursor: pointer;
  }
  .orderAndService > img {
    height: 18px;
    cursor: pointer;
  }
  /*内容区*/
  .content {
    display: flex;
    width: 100%;
    height: calc(100% - 45px);
  }
  .left {
    width: calc(100% - 180px);
  }
  .chat {
    height: 473px;
    overflow: auto;
  }
  .service {
    /*display: flex;*/
    margin: 40px 0 30px 10px;
  }
  .evaluate {
    display: flex;
    margin-bottom: 14px;
    min-width: 250px;
  }
  .evaluateP {
    display: flex;
    width: 90px;
    height: 26px;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 12px;
    background-color: #ed6b75;
    cursor: pointer;
    border: 1px solid #ed6b75;
    border-radius: 6px;
    margin: 0 auto;
  }
  /*.evaluateP:hover {*/
    /*color: #66a6ed;*/
  /*}*/
  .bar {
    width: 2px;
    height: 20px;
    margin-top: 4px;
    color: #66a6ed;
    background-color: #66a6ed;
  }

  .evaluateSession {
    width: 200px;
    height: 100px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #ffffff;
    font-size: 14px;
    color: #333333;
  }
  .evaluateSession > p {
    height: 34px;
    width: 154px;
    margin-left: 23px;
    line-height: 34px;
    border-bottom: 1px dashed #333333;
  }
  .evaluateSession > div {
    display: flex;
    margin-top: 10px;
    justify-content: center;
  }
  .satisfaction {
    text-align: center;
    margin-right: 66px;
  }
  .yawp {
    text-align: center;
  }
  .serviceSession {
    max-width: 80%;
    position: relative;
    margin-left: 65px;
  }
  .chatText {
    word-break: break-all;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 4px;
    margin-left: 10px;
    padding: 10px;
    font-size: 14px;
  }
  .topFive {
    margin-left: 20px;
    font-size: 14px;
  }
  .topFive li {
    color: #cccccc;
    margin-bottom: 16px;
  }
  .topFive a {
    color: #5987c2;
  }
  .user {
    display: flex;
    justify-content: flex-end;
    margin: 40px 10px 30px 0;
    position: relative;
  }
  .userSession {
    max-width: 80%;
  }
  .userText {
    word-break: break-all;
    background-color: #36c6d3;
    border: 1px solid #36c6d3;
    border-radius: 4px;
    margin-right: 10px;
    padding: 10px;
    color: #ffffff;
    font-size: 14px;
  }

  .chatContent {
    width: 97%;
    resize: none;
    margin: 5px 0 0 5px;
    height: 50px;
    font-size: 14px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #666666;
    border: 0;
    outline: 0;
  }
  footer {
    height: 100px;
    border: 1px solid #cccccc;
    border-right: 0;
    background-color: #ffffff;
    position: relative;
  }
  .send {
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .send > span {
    font-size: 14px;
    color: #999999;
    margin-right: 20px;
  }
  .sendBtn {
    width: 70px;
  }

  .right {
    width: 180px;
    width: 179px\9\0;
    height: 100%;
    border-left: 1px solid #cccccc;
  }
  .hotTitle {
    width: 100%;
    height: 40px;
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
    line-height: 40px;
    background-color: #fcfcfc;
  }
  .hotTitle>p {
    margin-left: 20px;
  }
  nav {
    width: 100%;
    font-size: 14px;
  }
  nav ul {
    margin-left: 20px;
  }
  nav li {
    margin: 15px 0 0 20px;
    color: #cccccc;
  }
  nav a {
    color: #5987c2;
  }
  .serviceImg {
    width: 50px;
    height: 50px;
    overflow: hidden;
    float: left;
  }
  .serviceImg img {
    width: 50px;
    border-radius: 100%;
  }
  .lenovo {
    width: 380px;
    background-color: #ffffff;
    box-shadow: 0 0 10px 0 rgba(47,92,143,0.4);
    border-radius: 6px;
    border: 1px solid #cccccc;
    position: absolute;
    left: 10px;
    bottom: 98px;
    font-size: 14px;
    padding: 10px;
  }
  .lenovo a {
    color: #5987c2;
    font-size: 14px;
  }
  .evaluated {
    width: 100%;
    text-align: center;
  }
  .sessionDiv {
    padding-bottom: 10px;
  }
  .sessionBar {
    width: calc(100% + 20px);
    transform: translateX(-10px);
    height: 1px;
    color: #cccccc;
    background-color: #cccccc;
  }
  .evaluateDiv {
    text-align: center;
  }
  .evalP {
    height: 30px;
    padding-top: 10px;
    font-size: 14px;
    color: #666666;
  }
  .evalDiv {
    width: 50%;
  }
  .getP {
    margin-left: 7px;
  }
  .evaluateBar {
    border-bottom: 1px dashed #cccccc;
    margin: 0 auto;
  }
  .topFiveP {
    text-align: center;
    font-size: 14px;
    color: #666666;
    margin: 10px 0;
  }
  .sessionSpan {
    display: inline-block;
    background: #fff;
    border: 1px solid #ccc;
    border-right: none;
    width: 10px;
    border-bottom: none;
    height: 10px;
    transform: rotate(-45deg);
    position: absolute;
    left: 5px;
    top: 15px;
  }
  .sessionUser {
    display: inline-block;
    background: #36c6d3;
    border: 1px solid #36c6d3;
    border-left: none;
    width: 10px;
    border-top: none;
    height: 10px;
    transform: rotate(-45deg);
    position: absolute;
    top: 10px;
    right: 48px;
  }
  .imgMask{
    position: absolute;
    top: 0;
    bottom:0;
    left: 0;
    right: 0;
    z-index: 1000;
    background:rgba(0,0,0,.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgMask img {
    position: relative;
    cursor: move;
    max-width: 640px;
  }
.tabs {
  float: left;
  display: flex;
  flex: 1;
  line-height: 0;
  padding-left: 20px;
}
.workOrder-box {
  overflow: hidden;
}
.workOrder-box .workOrder-item {
  width: 50%;
  box-sizing: border-box;
  padding: 0 5px;
  margin-bottom: 8px;
  float: left;
}
.workOrder-box .workOrder-item .workOrder-btn {
  width: 100%;
  height: 27px;
  color: #319bf3;
  font-size: 14px;
  line-height: 27px;
  padding: 0 12px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 4px;
  border: 1px solid #319bf3;
  box-sizing: border-box;
}
</style>
<style>
.tabs .el-tabs__header {
  margin: 0;
  border: none;
}
.tabs .el-tabs__item {
  color: #fff;
  padding: 0;
}
.tabs .el-tabs__item.is-active {
    color: #fff;
}
.tabs .el-tabs__active-bar {
  border-radius: 3px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/spirit/spirit.vue?29c7caf8